import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { BenefitTypeEnum } from '../../../api/payments/items/domain/enum';
import { BenefitTypeLabels } from '../../../api/payments/items/domain/labels';
import { normalizeBenefitType } from '../utils';
import { config } from '../../../../config/envs';

export function useItemDetailsBootstrap() {
  const { item_id: itemId } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItem = async () => {
      try {
        const response = await axios.get(
          `${config.app.adminBaseUrl}/items/${itemId}`,
        );
        setItem(response.data.data || response.data);
      } catch (error) {
        console.error('Erro ao buscar detalhes do produto', error);
        toast.error('Erro ao carregar os dados do produto.');
      } finally {
        setLoading(false);
      }
    };

    fetchItem();
  }, [itemId]);

  const formatCurrency = (value) =>
    Number(value || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

  const parseBoolean = (value) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;
    if (typeof value === 'string')
      return value.toLowerCase() === 'true' || value === '1';
    return Boolean(value);
  };

  const formatBenefitsType = (value) => {
    const normalized = normalizeBenefitType(value);

    if (!value) return BenefitTypeLabels[BenefitTypeEnum.CREDITS];
    if (BenefitTypeLabels[normalized]) return BenefitTypeLabels[normalized];

    return value || '-';
  };

  return {
    itemId,
    item,
    loading,
    formatCurrency,
    parseBoolean,
    formatBenefitsType,
  };
}
